import axios from 'axios';
import type { TagList } from '@bageltechnologies/bagel-api-client';

// Get the list of tags
export const getTags = (auth0: any): Promise<any> => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/tags/`;
      const response = await axios.get(url);
      resolve(response.data.tags);
    } catch (e: any) {
      console.error(e);
      reject(e);
    }
  });
};

// Create a new tag
export const createTag = (
  tagData: { category?: string, label: string; color: string, index: number },
  auth0: any
): Promise<any> => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/tags/`;
      const response = await axios.post(url, tagData);
      resolve(response.data.tag);
    } catch (e: any) {
      console.error(e);
      reject(e);
    }
  });
};

// Get a specific tag by ID
export const getTagById = (id: string, auth0: any): Promise<any> => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/tags/${id}`;
      const response = await axios.get(url);
      resolve(response.data.tag);
    } catch (e: any) {
      console.error(e);
      reject(e);
    }
  });
};

// Update a tag
export const updateTag = (
  id: string,
  tagData: { category?: string, label?: string; color?: string, index?: number },
  auth0: any
): Promise<any> => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/tags/${id}`;
      const response = await axios.put(url, tagData);
      resolve(response.data.tag);
    } catch (e: any) {
      console.error(e);
      reject(e);
    }
  });
};

// Delete a tag
export const deleteTag = (id: string, auth0: any): Promise<any> => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const url = `${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/tags/${id}`;
      const response = await axios.delete(url);
      resolve(response.data.message);
    } catch (e: any) {
      console.error(e);
      reject(e);
    }
  });
};

const PANTRY_TAGS_PATH = 'pantry/tags';

export const listTagSummaries = async (params: { pageSize: number }): Promise<TagList> => {
  const response = await axios.get<TagList>(`${window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN}/${PANTRY_TAGS_PATH}`, { params });
  return response.data;
};
